const DEFAULT_GA_ID = 'G-P0RZR040TT';
const DEFAULT_HOTJAR_ID = 6508733;
const HOTJAR_VERSION = 6;

const GA_ID = process.env.REACT_APP_GA_ID || DEFAULT_GA_ID;
const HOTJAR_ID = Number(process.env.REACT_APP_HOTJAR_ID || DEFAULT_HOTJAR_ID);

let initializationPromise = null;

const appendScriptOnce = ({ id, src }) => {
  const existing = document.getElementById(id);
  if (existing) return Promise.resolve(existing);

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = src;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Não foi possível carregar ${src}`));
    document.head.appendChild(script);
  });
};

const initializeGoogleAnalytics = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_ID);

  return appendScriptOnce({
    id: 'google-analytics-script',
    src: `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`,
  });
};

const initializeHotjar = () => {
  if (!Number.isFinite(HOTJAR_ID) || HOTJAR_ID <= 0) return Promise.resolve(null);

  window.hj = window.hj || function hj() {
    (window.hj.q = window.hj.q || []).push(arguments);
  };
  window._hjSettings = { hjid: HOTJAR_ID, hjsv: HOTJAR_VERSION };

  return appendScriptOnce({
    id: 'hotjar-script',
    src: `https://static.hotjar.com/c/hotjar-${HOTJAR_ID}.js?sv=${HOTJAR_VERSION}`,
  });
};

export const initializeThirdPartyTelemetry = () => {
  if (!initializationPromise) {
    initializationPromise = Promise.allSettled([
      initializeGoogleAnalytics(),
      initializeHotjar(),
    ]);
  }

  return initializationPromise;
};

export const scheduleAfterLoadAndIdle = (callback, { timeout = 2000 } = {}) => {
  let cancelled = false;
  let idleId = null;
  let timeoutId = null;

  const runWhenIdle = () => {
    if (cancelled) return;

    if ('requestIdleCallback' in window) {
      idleId = window.requestIdleCallback(() => {
        if (!cancelled) callback();
      }, { timeout });
      return;
    }

    timeoutId = window.setTimeout(() => {
      if (!cancelled) callback();
    }, Math.min(timeout, 1500));
  };

  const handleLoad = () => runWhenIdle();

  if (document.readyState === 'complete') {
    runWhenIdle();
  } else {
    window.addEventListener('load', handleLoad, { once: true });
  }

  return () => {
    cancelled = true;
    window.removeEventListener('load', handleLoad);
    if (idleId !== null && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(idleId);
    }
    if (timeoutId !== null) {
      window.clearTimeout(timeoutId);
    }
  };
};
